import { render, staticRenderFns } from "./RegisterLitterForm1.vue?vue&type=template&id=a55b973e"
import script from "./RegisterLitterForm1.vue?vue&type=script&lang=ts"
export * from "./RegisterLitterForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports